<template>
  <div id="app">
<!--    <img src="./assets/logo.png">-->
    <router-view/>
  </div>
</template>

<script>
  // import 'bootstrap/dist/css/bootstrap.min.css'
  // import 'bootstrap/dist/js/bootstrap.min'
export default {
  name: 'App',
  data(){
    return{

    }
  },
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
    height: 100% ;
  /*text-align: center;*/
  /*color: #2c3e50;*/
  /*margin-top: 60px;*/
}
html,body{
  width: 100%;
  height: 100%;
 
   
}
 /* 背景色  */
 .mainBg{
        background: #F5F4F2!important;
  }
</style>




// WEBPACK FOOTER //
// src/App.vue